<template>
    <section class="magazine-filter">
      <button class="magazine-filter__button active">Starters</button>
      <button class="magazine-filter__button">The Main Event</button>
      <button class="magazine-filter__button">Desserts</button>
      <button class="magazine-filter__button">Sweet Treats</button>
      <button class="magazine-filter__button">For Sharing</button>
      <button class="magazine-filter__button">Vegan</button>
      <!-- <button class="magazine-filter__button">Free From</button>
        <button class="magazine-filter__button">Extra One</button>
          <button class="magazine-filter__button">Extra Two</button>
            <button class="magazine-filter__button">Extra Three</button>
               <button class="magazine-filter__button">Extra Four</button> -->
  </section>
</template>

<script>
export default {
  name: 'TheFilterMagazine'
}
</script>

<style lang="postcss">
.magazine-filter {
  @apply  px-6 py-4 flex overflow-x-scroll;
}
.magazine-filter__button {
  @apply bg-white text-body font-medium py-2 mx-0 px-6  mr-2 border-secondary border whitespace-no-wrap rounded-full text-sm;
}
.magazine-filter__button.active {
  @apply border-secondary text-white bg-secondary;
}
.magazine-filter__button:hover {
  @apply text-secondary;
}
.magazine-filter__button.active:hover {
  color:#F6F4ED;
}
.magazine-filter__button:focus {
  @apply outline-none;
}
.magazine-filter__button:last-of-type {
  @apply mr-0;
}
@screen md {
  .magazine-filter__button {
  @apply text-base;
}
}

/* @screen lg {
  .magazine-filter {
    @apply overflow-hidden;
  }
  .magazine-filter__button {
    @apply mr-2 text-base;
  }
} */
</style>
